export const versionService = {
    getVersion,
};


function getVersion() {
    const payload = {
      isAjax: true,
    };
  
    const requestOptions = {
      method: 'GET',
      headers: {
        "use-pkey": false
      }
    };

    return fetch('/version', requestOptions);
  
  }